import clsx from 'clsx';
import { TooltipComponent } from './Tooltip';
import { QuestionIcon } from '../../icons/questionIcon';
import { InfoIcon } from '../../icons';

export const TextField = ({
  className,
  labelClassName,
  wrapperClass,
  type,
  label,
  value,
  icon,
  error,
  prefix,
  ...props
}) => {
  const validateNumber = (event) => {
    const keyCode = event.keyCode;

    const excludedKeys = [8, 37, 39, 46];

    if (
      !(
        (keyCode >= 48 && keyCode <= 57) ||
        (keyCode >= 96 && keyCode <= 105) ||
        excludedKeys.includes(keyCode)
      )
    ) {
      event.preventDefault();
    }
  };

  return (
    <div className={clsx('flex flex-col gap-1', wrapperClass)}>
      {label !== undefined && (
        <div className='flex gap-1 items-center'>
          <label htmlFor={props?.id} className={clsx("text-label text-fadedgrey", labelClassName)}>
            {label}
          </label>
          {props.id === 'password' && 
          <TooltipComponent side="right" content={
            <div className='w-52 lg:w-72'>
            <p>Ο κωδικός πρέπει να έχει ελάχιστο μήκος 10 χαρακτήρων και να περιλαμβάνει χαρακτήρες από τρεις από τις παρακάτω κατηγορίες:</p>
            <ul>
              <li>• Κεφαλαία γράμματα (Α έως Ζ).</li>
              <li>• Πεζά γράμματα (α έως ζ).</li>
              <li>• Δεκαδικά ψηφία (0 έως 9).</li>
              <li>• {`Μη αλφαριθμητικοί χαρακτήρες (~!@#$%^&*_-+=|\(){}[]:;"'<>,.?/)`}. Τα σύμβολα νομισμάτων, όπως το ευρώ ή η βρετανική λίρα, δεν υπολογίζονται ως ειδικοί χαρακτήρες.</li>
            </ul>
            </div>
             }>
             <div>
                 <QuestionIcon className={'cursor-pointer w-3 h-3'}/>
             </div>
         </TooltipComponent>}
         {(props.id === 'email' && !!props.isDriverEmailDisabled) &&
          <TooltipComponent activateOnHover={true} side="top" content={
            <div className='w-52 lg:w-72'>
              <p>Για να αλλάξεις το email, θα πρέπει να διαγράψεις τον οδηγό και να καταχωρίσεις εκ νέου όλα τα στοιχεία.</p>
            </div>
             }>
             <div>
                <InfoIcon className={'cursor-pointer w-5 h-5'}/>
             </div>
         </TooltipComponent>}
        </div>
      )}
      {type === 'phone' ? (
        <>
        <div
          className={clsx(
            'flex gap-2 rounded-[8px] border border-[#A5A5A5] p-2 bg-white',
            props.disabled && 'text-[#A5A5A5]',
            className
          )}
        >
          <input
            value={value}
            type={'tel'}
            onKeyDown={validateNumber}
            {...props}
          />
        </div>
        {error && <p className="text-label text-primary">{error}</p>}
      </>
        
      ) : type === 'textarea' ? (
        <>
          <div
            className={clsx(
              'flex gap-2 rounded-[8px] border border-[#A5A5A5] p-2 bg-white',
              props.disabled && 'text-[#A5A5A5]',
              className
            )}
          >
            {icon && icon}
            <textarea
              {...props}
              className="outline-0 w-full placeholder:text-label max-h-[8em] overflow-auto"
              value={value}
              rows={4}
                
            />
          </div>
          {error && <p className="text-primary text-label">{error}</p>}
        </>
      ) : 
      <>
      <div
        className={clsx(
          'flex gap-2 rounded-[8px] border border-[#A5A5A5] p-2 bg-white',
          props.disabled && 'text-[#A5A5A5]',
          className
        )}
      >
        {icon && icon}
        <input
          {...props}
          className="outline-none appearance-none focus:outline-none w-full placeholder:text-label"
          value={value}
          type={type !== undefined ? type : 'text'}
        />
        {prefix && <p className="left-16 text-black">
          {prefix}
        </p>}
      </div>
      {error && <p className="text-primary text-label">{error}</p>}
    </>
      }
    </div>
  );
};
